import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { ApiService, TokenService } from '../../api';
import { EnvironmentService } from '../../services/environment.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginBase } from '../models';

@Injectable({
  providedIn: 'root',
})
export class MockAuthenticationService extends AuthenticationService {
  constructor(
    readonly environmentService: EnvironmentService,
    readonly tokenService: TokenService,
    readonly apiService: ApiService,
    readonly router: Router,
    readonly http: HttpClient,
  ) {
    super(environmentService, tokenService, apiService, router, http);
  }

  /**
   * This function registrate one user to the API.
   *
   * @param {{
   *     firstName: string;
   *     lastName: string;
   *     email: string;
   *     password: string;
   *     passwordConfirmation: string;
   *   }} user
   * @returns {Observable<boolean>}
   * @memberof UserAuthenticationService
   */
  public registrateUser(user: {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    passwordConfirmation: string;
  }): Observable<boolean> {
    console.log(user);
    return this.fakeCall();
  }

  /**
   * This function gains the Tokens from the JWT api.
   *
   * @param {LoginData} loginData
   * @returns {Observable<boolean>}
   * @memberof UserAuthenticationService
   */
  public obtainAccessToken(loginData: LoginBase): Observable<boolean> {
    console.log(loginData);
    return this.fakeCall();
  }

  /**
   * This runs once on application startup.
   *
   * @param {boolean} [navigation=true] Defines, if you would like to navigate to login.
   * @returns {Observable<boolean>}
   * @memberof UserAuthenticationService
   */
  public initialize(navigation = true): void {
    console.log(navigation);
    this.setAuth(undefined);
  }

  /**
   * This function resets the Access token.
   *
   * @private
   * @param {string} token
   * @returns {Observable<boolean>}
   * @memberof UserAuthenticationService
   */
  protected refreshAccessToken(): Observable<boolean> {
    return this.fakeCall();
  }

  private fakeCall(): Observable<boolean> {
    return new Observable<boolean>(o => {
      this.handleSuccess({ access_token: 'mock', expires_in: '1000', refresh_token: 'mock' });
      o.next(true);
    });
  }
}
